import { branch, renderNothing, withProps } from 'recompose'
import getCorrectFilter from 'helpers/custom-price-filter'
import FilterBreadcrumbs from './components/FilterBreadcrumbs'

const withCorrectFilter = withProps(({ selectedFilters = []}) => ({
  selectedFilters: getCorrectFilter(selectedFilters)
}))

export default branch(
  ({ selectedFilters = []}) => selectedFilters.length === 0,
  renderNothing,
  withCorrectFilter
)(FilterBreadcrumbs)
